import React from "react";
import { EuiIconTip, EuiSpacer, EuiText } from "@elastic/eui";
import { MarkdownText } from "../markdown_text";
import { useAnketa } from "../context_provider";
import { TextCardProps } from "src/questionnaires/types";

export const TextCard = ({ text }: TextCardProps): JSX.Element => {
  const ctx = useAnketa();

  if (!text.visible) {
    return <div></div>;
  }

  return (
    <EuiText>
      {text.help && (
        <div
          style={{
            display: "flex",
            flexDirection: "row-reverse",
          }}
        >
          <EuiIconTip
            aria-label={text.id}
            size="m"
            type="questionInCircle"
            color="primary"
            content={ctx.i18nContext.render(text.help)}
          />
        </div>
      )}
      <MarkdownText text={text.title} />
      <EuiSpacer />
    </EuiText>
  );
};
